module.exports = __webpack_public_path__ + "static/images/no-data-legend.dd8d65434b74396592e1b6618d15a7df.svg";